/* No framework or global selectors. Reconnects after Shopify section reloads. */
(() => {
  if (customElements.get("hsn-advertorial")) return;

  class HsnAdvertorial extends HTMLElement {
    connectedCallback() {
      // A dynamically inserted section may connect before its children are parsed.
      this.cancelInitialization = requestAnimationFrame(() =>
        this.initialize(),
      );
    }

    initialize() {
      if (!this.isConnected) return;
      this.events?.abort();
      this.events = new AbortController();
      const { signal } = this.events;

      this.querySelectorAll("[data-hsn-comparison]").forEach((comparison) => {
        const range = comparison.querySelector('input[type="range"]');
        if (!range) return;
        const update = () => {
          const value = Math.min(100, Math.max(0, Number(range.value)));
          comparison.style.setProperty("--position", `${value}%`);
          range.setAttribute(
            "aria-valuetext",
            `${value}% before image visible`,
          );
        };
        range.addEventListener("input", update, { signal });
        update();
      });

      const sticky = this.querySelector("[data-hsn-sticky]");
      const offer = this.querySelector("[data-hsn-offer]");
      if (!sticky || !offer) return;

      const updateSticky = () => {
        this.scrollFrame = 0;
        const sectionBounds = this.getBoundingClientRect();
        const offerBounds = offer.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const withinArticle =
          sectionBounds.top < -620 && sectionBounds.bottom > 0;
        const offerVisible =
          offerBounds.top < viewportHeight && offerBounds.bottom > 0;
        sticky.hidden = !withinArticle || offerVisible;
      };
      const scheduleUpdate = () => {
        if (!this.scrollFrame)
          this.scrollFrame = requestAnimationFrame(updateSticky);
      };
      window.addEventListener("scroll", scheduleUpdate, {
        passive: true,
        signal,
      });
      window.addEventListener("resize", scheduleUpdate, {
        passive: true,
        signal,
      });
      window.addEventListener("pageshow", scheduleUpdate, { signal });
      this.resizeObserver = new ResizeObserver(scheduleUpdate);
      this.resizeObserver.observe(this);
      updateSticky();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.cancelInitialization);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = 0;
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define("hsn-advertorial", HsnAdvertorial);
})();
